import Vue from 'vue';
import Router from 'vue-router';
import { TokenService } from './services/storage.service';
import Home from './views/Home.vue';
import Main from './views/Main.vue';
import Login from './views/Login.vue';
import Logout from './views/Logout.vue';

import Active from './views/Active.vue';
import Canceled from './views/Canceled.vue';
import Done from './views/Done.vue';
import Draft from './views/Draft.vue';
import Processing from './views/Processing.vue';
import Queue from './views/Queue.vue';
import Returned from './views/Returned.vue';
import Transferred from './views/Transferred.vue';
import Request from './views/Request.vue';
import RequestPrint from './views/RequestPrint.vue';
import User from './views/User.vue';
import ProcessForm from './views/ProcessForm.vue';
import store from './store/store';
import Completed from './views/Completed.vue';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    // по умолчанию считаем, что все пути в закрытой части и требует авторизации
    // пути публичной части необходимо отмечать метаинформацией public = true
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: {
                title: 'Стартовая страница',
                titleIcon: 'mdi-home',
                showInMainMenu: true,
                public: true
            }
        },
        {
            path: '/active',
            name: 'active',
            component: Active,
            meta: {
                title: 'Активные заявки',
                titleIcon: 'mdi-fire',
                showInMainMenu: true,
                subitems: true,
                statusName: 'Активные заявки'
            }
        },
        {
            path: '/draft',
            name: 'draft',
            component: Draft,
            meta: {
                title: 'Черновик',
                //titleIcon: 'mdi-folder-multiple',
                showInMainMenu: true,
                parentItemName: 'active',
                statusName: 'Черновик'
            }
        },
        {
            path: '/returned',
            name: 'returned',
            component: Returned,
            meta: {
                title: 'Возвращена потребителю',
                //titleIcon: 'mdi-folder-multiple',
                showInMainMenu: true,
                parentItemName: 'active',
                statusName: 'Возвращена потребителю'
            }
        },
        {
            path: '/processing',
            name: 'processing',
            component: Processing,
            meta: {
                title: 'В работе',
                titleIcon: 'mdi-file-multiple',
                showInMainMenu: true,
                subitems: true,
                statusName: 'В работе'
            }
        },
        {
            path: '/queue',
            name: 'queue',
            component: Queue,
            meta: {
                title: 'На рассмотрении',
                //titleIcon: 'mdi-folder-multiple',
                showInMainMenu: true,
                parentItemName: 'processing',
                statusName: 'На рассмотрении'
            }
        },
        {
            path: '/transferred',
            name: 'transferred',
            component: Transferred,
            meta: {
                title: 'Передано в РЭС',
                //titleIcon: 'mdi-folder-multiple',
                showInMainMenu: true,
                parentItemName: 'processing',
                statusName: 'Передано в РЭС'
            }
        },
        {
            path: '/completed',
            name: 'completed',
            component: Completed,
            meta: {
                title: 'Завершённые',
                titleIcon: 'mdi-calendar-multiple-check',
                showInMainMenu: true,
                subitems: true,
                statusName: 'Завершённые'
            }
        },
        {
            path: '/done',
            name: 'done',
            component: Done,
            meta: {
                title: 'Исполнено',
                //titleIcon: 'mdi-folder-multiple',
                showInMainMenu: true,
                parentItemName: 'completed',
                statusName: 'Исполнено'
            }
        },
        {
            path: '/canceled',
            name: 'canceled',
            component: Canceled,
            meta: {
                title: 'Отменено',
                //titleIcon: 'mdi-folder-multiple',
                showInMainMenu: true,
                parentItemName: 'completed',
                statusName: 'Отменено'
            }
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                title: 'Вход',
                titleIcon: 'mdi-login',
                showInMainMenu: true,
                public: true,
                onlyWhenLoggedOut: true
            }
        },
        {
            path: '/login/:auth',
            name: 'loginAuth',
            component: Login,
            props: true,
            meta: {
                showInMainMenu: false,
                public: true,
                onlyWhenLoggedOut: false
            }
        },
        {
            path: '/logout',
            name: 'logout',
            component: Logout,
            meta: {
                title: 'Выход',
                titleIcon: 'mdi-logout',
                showInMainMenu: true
            }
        },
        {
            path: '/request',
            name: 'request',
            component: Request,
            meta: {
                showInMainMenu: false
            }
        },
        {
            path: '/request-print',
            name: 'request-print',
            component: RequestPrint,
            meta: {
                showInMainMenu: false
            },
            props: true
        },
        {
            path: '/processform',
            name: 'processform',
            component: ProcessForm,
            props: true,
            meta: {
                showInMainMenu: false
            }
        },
        {
            path: '/user',
            name: 'user',
            component: User,
            meta: {
                showInMainMenu: false
            }
        }
    ]
});

router.beforeEach((to, from, next) => {
    const isPublic = to.matched.some(record => record.meta.public);
    const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut);
    const loggedIn = !!TokenService.getToken();

    if (!isPublic && !loggedIn) {
        return next({
            path: '/login',
            query: { redirect: to.fullPath } // Store the full path to redirect the user to after login
        });
    }

    // Do not allow user to visit login page or register page if they are logged in
    if (loggedIn && onlyWhenLoggedOut) {
        return next('/');
    }

    next();
});

router.afterEach((to, from) => {
    if (to.name != 'logout' && from.name != 'logout' && from.name != 'login') {
        // на страницах login и logout свой вызов перестроения меню
        store.dispatch('toolbar/reloadMenuItems');
    }
});

export default router;
